import React from 'react';
import {
  Title,
  ProductImage,
  QuotationCard,
  QuotationCardContent,
  ProductName,
  ProductCategory,
  RemoveButton,
  RequestQuotationButton,
  EmptyQuotationText,
  ProductButtons
} from './QuotationOverlay.styled'
import kebabToTitleCase from '../../utils/kebabToTitleCase';
import useStore from '../../store/useStore';
import QuantityButtons from '../QuantityButtons/QuantityButtons';
import {FaTrash} from 'react-icons/fa';
import { useNavigate } from 'react-router';

const QuotationOverlay = () => {
  const navigate = useNavigate();
  const products = JSON.parse(localStorage.getItem('products')) || {};

  const { setProducts, removeProduct } = useStore();


  const onAddToQuotation = (product, selectedVariant, count) => {
    // const newProduct = {
    //   [product.id]: {
    //     ...product,
    //     quantity: count
    //   }
    // }
    // setProducts(newProduct);
    const existingProduct = product;

    const newVariants = existingProduct.variants.map(variant => {
      if (variant.name === selectedVariant.name) {
        return {
          ...variant,
          quantity: count
        };
      }
      return variant;
    });

    const updatedProduct = {
      ...existingProduct,
      variants: newVariants
    };

    setProducts({
      ...products, // <-- preserve all other products
      [existingProduct?.id]: updatedProduct
    });
  }

  const removeProductFromQuotation = (productId) => {
    removeProduct(productId);
  }


  return (
    <div>
      <Title>{`Quotation Request (${products && Object.keys(products).length})`}</Title>
      {Object.keys(products).length === 0 && (
        <EmptyQuotationText>Produk belum ditambahkan</EmptyQuotationText>
      )}
      {Object.keys(products).flatMap((productId) => {
        const product = products[productId];
        return product?.variants
          .filter((variant) => parseInt(variant.quantity) > 0) // 👈 only keep variants with quantity > 0
          .map((variant, idx) => {
            const quantity = parseInt(variant.quantity);
            return (
              <QuotationCard key={`${productId}-${idx}`}>
                <ProductImage width={200} src={variant.image} alt={product.name} />
                <QuotationCardContent>
                  <ProductName>{product.name}</ProductName>
                  <ProductCategory>{variant?.name}</ProductCategory>
                  <ProductCategory>{kebabToTitleCase(product.category)}</ProductCategory>
                  <ProductButtons>
                    <QuantityButtons
                      quantity={quantity}
                      onClickAdd={() => onAddToQuotation(product, variant, quantity + 1)}
                      onClickSubtract={() => onAddToQuotation(product, variant, Math.max(0, quantity - 1))}
                    />
                    <RemoveButton onClick={() => removeProductFromQuotation(product?.id)}>
                      <FaTrash size={16} color="#fff" />
                    </RemoveButton>
                  </ProductButtons>
                </QuotationCardContent>
              </QuotationCard>
            );
          });
        })}
      <RequestQuotationButton disabled={Object.keys(products).length === 0} onClick={() => navigate('/quotation')}>
        Request for Quotation
      </RequestQuotationButton>
    </div>
  )
}

export default QuotationOverlay;